/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Headline_2Inputs */

const et_hero_headline_2 = /** @type {(inputs: Hero_Headline_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`päringuid esimese `)
};

const en_hero_headline_2 = /** @type {(inputs: Hero_Headline_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inquiries within the first `)
};

/**
* | output |
* | --- |
* | "inquiries within the first" |
*
* @param {Hero_Headline_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_headline_2 = /** @type {((inputs?: Hero_Headline_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Headline_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_headline_2(inputs)
	return en_hero_headline_2(inputs)
});